<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <div id="my-table-id">
        <v-data-table :headers="headers" :items="salary_component_type_list" dense class="elevation-1 mytable"
          :search="search">
          <template v-slot:top>
            <v-toolbar dense class="toolbar" flat color="white">
              <v-toolbar-title>Salary Component Type</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>

            <span style="width: 20px"> </span>
            <v-row dense>
              <v-col cols="12" sm="3" md="3">
                <!-- <v-btn
                color="success"
                outlined
                rounded
                v-if="salary_component_type_list.length != 0"
              >
                <download-excel
                  class="mr-2 pb-3 pt-2"
                  :data="salary_component_type_list"
                  :fields="table_fields"
                  worksheet="PayRoll_SalaryComponentType"
                  name="PayRoll_SalaryComponentType.xls"
                >
                  <v-icon dark>mdi-file-excel</v-icon> Export
                </download-excel>
              </v-btn> -->
                <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'SalaryComponentType')"
                  :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
              </v-col>
              <v-col sm="6" md="4" cols="12">
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                </v-text-field>
              </v-col>
              <span style="width: 20px"></span>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn class="mb-2 button" v-on="on" small>Add Salary Component Type</v-btn>
                </template>
                <v-card>
                  <v-form v-model="valid">
                    <v-card-title class="toolbar">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedItem.component_type_name" :disabled="editedIndex != -1"
                              persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: Earning, Deduction...'
                                : 'noneditable'
                            " label="Salary Component" :rules="[(v) => !!v || 'required']">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field v-model="editedItem.component_type_display_name" label="Display Name"
                              hint="Earning, Deduction..." :rules="[(v) => !!v || 'required']"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                            <v-checkbox dense v-model="editedItem.status" color="success" label="Active"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                      <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <template v-slot:item.status="{ item }">
            <v-switch v-model="item.status" inset color="success" @change="toggleGroup(item)"></v-switch>
          </template>
          <template v-slot:item.action="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    // extraBreadcrumbItems: [
    //   { text: "Salary Component Type", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    valid: false,
    overlay: false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Sr No.",
        align: "left",
        sortable: false,
        value: "srno",
      },
      {
        text: "Component Name",
        align: "left",
        sortable: false,
        value: "component_type_name",
      },
      {
        text: "Display Name",
        align: "left",
        sortable: false,
        value: "component_type_display_name",
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "status",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      "Sr No.": "srno",
      "Component Name": "component_type_name",
      "Display Name": "component_type_display_name",
      Status: "status",
    },
    salary_component_type_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      component_type_name: "",
      status: true,
    },
    defaultItem: {
      id: "",
      component_type_name: "",
      status: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Salary Component Type"
        : "Edit Salary Component Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr.No.</th>
      <th>Component Name</th>
      <th>Display Name</th>
      <th>Status</th>
      
    </tr>`;

  this.salary_component_type_list.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td> 
        <td>${item.component_type_name || ''}</td> 
        <td>${item.component_type_display_name || ''}</td> 
        <td>${item.status ? 'Active' : 'Inactive'}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    toggleGroup(item) {
      const formData = {
        id: item.id,
        status: item.status,
      };
      axios
        .post("/Payroll/toggleComponentStatus", formData)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Salary Component Status Changed...");
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        });
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/salaryComponentHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.salary_component_type_list = res.data.component_types_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.salary_component_type_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Payroll/editSalaryComponentType", this.editedItem)
            .then((res) => {
              if (res.data.status == "YES") {
                Object.assign(
                  this.salary_component_type_list[this.editedIndex],
                  this.editedItem
                );
                this.onLoad();
                this.showSnackbar(
                  "#4caf50",
                  "Salary Component Type Updated Successfully..."
                ); // show snackbar on success
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Salary Component Type Already Present!!!"
                ); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/Payroll/saveSalaryComponentType", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.salary_component_type_list.push(this.editedItem);
              this.onLoad();
              this.showSnackbar(
                "#4caf50",
                "Salary Component Type Added Successfully..."
              ); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Salary Component Type Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.component_type_name) {
        return true;
      } else {
        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>